import { AsFn } from '@main/shared/types';
import { useCallback } from 'react';

import { useRefed } from './refed';

/**
 * Returns a stable version of the callback that never changes but calls latest provided callback.
 */
// eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
export function useStableCallback<TFn extends Function>(callback?: TFn) {
  const cbRef = useRefed(callback);
  return useCallback(
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    (...args: Parameters<AsFn<TFn>>): ReturnType<AsFn<TFn>> => cbRef.current?.(...args),
    // oxlint-disable-next-line react/exhaustive-deps
    [],
  );
}
